import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ChevronLeftIcon from './icons/ChevronLeft';

export const PageHeadContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
  max-width: 100%;
  row-gap: 1rem;
`;

export const PageTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  & h1 {
    font-weight: 500;
    font-size: 1.5rem;
    margin-right: 1rem;
  }
`;

export const HeadButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

const PageBackLink = styled(Link)`
  stroke: var(--gray-900);
  margin-right: 1.5rem;
`;
type PageBackProps = {
  href: string;
};
export const PageBack: FC<PageBackProps> = ({ href }) => {
  return (
    <PageBackLink to={href}>
      <ChevronLeftIcon />
    </PageBackLink>
  );
};
